import { useSelector } from 'react-redux';
import { PolicyWrapper } from './style';
import { selectPolicy } from './selectors';
import { removeScripts } from '@utils/helper';
import OptimizedImage from '@components/OptimizeImage';

const Policy = () => {
  const policy = useSelector(selectPolicy);

  return (
    <PolicyWrapper className="pb-20 max-md:pb-15">
      <div className="relative h-[60vh] after:absolute after:top-0 after:left-0 after:size-full after:bg-[linear-gradient(rgba(0,0,0,0.5)_0%,rgba(0,0,0,0)_16.42%,rgba(0,0,0,0.114)_34.1%,rgba(0,0,0,0.29)_100%)] after:content-['']">
        <OptimizedImage
          src={policy?.imageResize?.thumb1920}
          className="size-full"
          sizes="100vw"
          priority
        />
        <div className="container-fluid absolute bottom-10 left-1/2 z-1 -translate-x-1/2 text-center text-white">
          <div className="segTitle relative w-max after:absolute after:bottom-4 after:left-[calc(100%+20px)] after:w-25 after:border-b after:border-white after:content-[''] max-md:w-full max-md:text-center max-md:after:hidden">
            {policy?.title}
          </div>
        </div>
      </div>
      <div className="container-fluid overflow-x-hidden">
        <article
          className="relative mt-15 ml-55 text-justify before:absolute before:top-2 before:-left-55 before:w-49 before:border-b-4 before:border-primary before:content-[''] max-md:ml-0 max-md:before:hidden"
          dangerouslySetInnerHTML={{
            __html: removeScripts(policy?.content) || '',
          }}
        />
      </div>
    </PolicyWrapper>
  );
};

export default Policy;
